// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__3Ppwp","header":"Messages_header__309c8"};